var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-container',{staticClass:"kst-dispatch-related"},[_c('kst-section',{attrs:{"title":_vm.title}},[_c('List',{attrs:{"access":_vm.access,"failureList":_vm.failureList,"isListLoading":_vm.isListLoading,"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }